<template>
  <div>
    <OrderWidget :code="code"></OrderWidget>
    <!--    <PaySuccess v-bind:dialog.sync="testDialog"></PaySuccess>-->
  </div>
</template>

<script>
import OrderWidget from "@/view/pages/pay/OrderWidget";
// import PaySuccess from "@/view/pages/pay/PaySuccess";
export default {
  name: "tunnel-order",
  components: {
    // PaySuccess,
    OrderWidget,
  },
  data() {
    return {
      dialog: false,
      code: "tunnel",
      testDialog: true,
    };
  },
};
</script>
